
const possuiPermissao = (rota) => {

  const rotasPermissionadas = localStorage['sgp-usuario']
  const ehUmaListaDeRotas = Array.isArray(rota)

  // caso seja uma lista de rotas
  // escapa true na primeira rota encontrada
  if (ehUmaListaDeRotas) {
    let permissao = false
    rota.forEach(r => {
      if (rotasPermissionadas.includes(r)) {
        permissao = true
        return true
      }
    })
    return permissao
  }

  return rotasPermissionadas.includes(rota)
}

export {
  possuiPermissao
}